import { MENU_KEY } from '../constants'


export const setMenuKey = (data) => ({
    type: MENU_KEY,
    payload: data
})
